module.exports = __webpack_public_path__ + "static/media/Ryan Giesen.b6ad3951.png";